$(window).on('load', function(){
    console.log('Load Tipo de Cliente -- ElCultivo')
    /* Página: M A R C A S */
    if($('#single_product').length ){
        if( window.location.href.indexOf('tipo') ){
            let tipo = getQueryVariable("tipo")
            const myLink = $('#type_brand');
            if( tipo == 'menudeo' ){
                const menudeo = $(myLink).data('menudeo');
                const collection = $('#type_collection');
                const collection_url = $(collection).attr('href');
                const newUrl = collection_url + '-menudeo';
                collection.attr('href', newUrl);
                myLink.attr('href', menudeo);
                $('#client_menudeo').removeClass('hidden-first');
                $('#client_mayoreo').remove();
            }else{
                const mayoreo = $(myLink).data('mayoreo');
                myLink.attr('href', mayoreo);
                $('#client_mayoreo').removeClass('hidden-first');
                $('#client_menudeo').remove();
            }
        }
    }
    /* END Página: M A R C A S  */
});

function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}